<template>
  <div class="team-card-container">
    <v-card class="team-card" flat>
      <img v-if="parsedImg" loading="lazy" :src="parsedImg" />
      <div class="d-flex flex-column justify-center">
        <v-card-title>{{ title }}</v-card-title>
        <v-card-subtitle v-if="subtitle">
          {{ subtitle }}
        </v-card-subtitle>
        <v-card-text v-if="email || whatsapp" class="pt-0">
          <v-btn
            v-if="email"
            class="text-none d-flex"
            :href="emailLink"
            width="min-content"
            small
            text
          >
            <v-icon left>fas fa-envelope</v-icon>
            <span>{{ email }}</span>
          </v-btn>
          <v-btn
            v-if="whatsapp"
            class="text-none d-flex"
            :href="whatsappLink"
            width="min-content"
            target="_blank"
            small
            text
          >
            <v-icon left small>fab fa-whatsapp</v-icon>
            <span>{{ whatsapp }}</span>
          </v-btn>
        </v-card-text>
      </div>
    </v-card>
  </div>
</template>

<script>
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";
import DefaultImg from "../../assets/img/default-img.png";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
    },
    img: {
      type: String,
    },
    whatsapp: {
      type: String,
    },
    email: {
      type: String,
    },
  },
  computed: {
    parsedImg() {
      if (!this.img) {
        return DefaultImg;
      }

      let img = "";

      if (!/^https?:\/\//.test(this.img)) {
        img = this.files;
      }

      img += this.img;

      return `${img}?resize=1&w=400`;
    },
    emailLink() {
      return `mailto:${this.email}`;
    },
    whatsappLink() {
      return getWhatsappLinkFromPhone(this.whatsapp);
    },
  },
};
</script>

<style lang="scss">
.team-card-container {
  container-name: team-card;
  container-type: inline-size;

  .team-card {
    display: grid;
    grid-template-columns: max-content auto;
    grid-template-rows: 160px;
    border: 1px solid #ccc !important;

    img {
      aspect-ratio: 1;
      object-fit: cover;
      height: 100%;
      width: 100%;
    }

    @container team-card (max-width: 500px) {
      grid-template-columns: auto !important;
      grid-template-rows: auto;

      .v-card__title,
      .v-card__subtitle,
      .v-card__text {
        padding: 8px 8px 8px 8px;
      }
    }
  }
}
</style>
